import { render } from "./ReadEmail.vue?vue&type=template&id=86558eb2&ts=true"
import script from "./ReadEmail.vue?vue&type=script&lang=ts"
export * from "./ReadEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__